export const SET_TRIGGERS_TABLE_THRESHOLD = 'SET_TRIGGERS_TABLE_THRESHOLD';

export const setTriggersTableThreshold = threshold => {
  return {
    type: SET_TRIGGERS_TABLE_THRESHOLD,
    data: threshold,
  };
};
